import React from "react";
import { SortingState } from "@tanstack/react-table";
import { twMerge } from "tailwind-merge";

import Icons from "assets";

export const getSortIcon = (
  sortingParams: SortingState,
  columnId: string,
  enableSorting?: boolean,
): React.ReactNode => {
  if (!enableSorting || sortingParams.length === 0) {
    return null;
  }

  const sortedItem = sortingParams.find((sort) => sort.id === columnId);

  return (
    <Icons.ArrowRight
      style={{ flexShrink: 0 }}
      customClass={twMerge(
        sortedItem ? "text-aqua-600" : "text-gray-900",
        sortedItem?.desc ? "-rotate-90" : "rotate-90",
      )}
    />
  );
};
